// extracted by mini-css-extract-plugin
export default {"title":"THInfoModal_title__k9Zmt"};